module.exports = __webpack_public_path__ + "img/change_all.74a1b17f.png";